import StagingNetsCourseworkLayout from './staging_nets_coursework_layout.jsx'

const StagingNetsCourseworkPage = () => {
  return (
      <StagingNetsCourseworkLayout />
  );
};

export default StagingNetsCourseworkPage;